/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressGetDeleteImpact } from "../funcs/networkIngressGetDeleteImpact.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NetworkIngressDeleteImpact } from "../models/components/networkingressdeleteimpact.js";
import {
  GetNetworkIngressDeleteImpactRequest,
  GetNetworkIngressDeleteImpactSecurity,
} from "../models/operations/getnetworkingressdeleteimpact.js";
import { unwrapAsync } from "../types/fp.js";
export type NetworkIngressGetDeleteImpactQueryData = NetworkIngressDeleteImpact;

export function prefetchNetworkIngressGetDeleteImpact(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetNetworkIngressDeleteImpactRequest | undefined,
  security?: GetNetworkIngressDeleteImpactSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildNetworkIngressGetDeleteImpactQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildNetworkIngressGetDeleteImpactQuery(
  client$: GramCore,
  request?: GetNetworkIngressDeleteImpactRequest | undefined,
  security?: GetNetworkIngressDeleteImpactSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<NetworkIngressGetDeleteImpactQueryData>;
} {
  return {
    queryKey: queryKeyNetworkIngressGetDeleteImpact({
      gramSession: request?.gramSession,
    }),
    queryFn: async function networkIngressGetDeleteImpactQueryFn(
      ctx,
    ): Promise<NetworkIngressGetDeleteImpactQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(networkIngressGetDeleteImpact(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyNetworkIngressGetDeleteImpact(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "networkIngress", "getDeleteImpact", parameters];
}
